import { render } from "./ExceptionDialog.vue?vue&type=template&id=17fa6a88"
import script from "./ExceptionDialog.vue?vue&type=script&lang=js"
export * from "./ExceptionDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/NfzNB5gn/0/softbot/chatbot/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard});
